import { Browser, isNullOrUndefined } from '@syncfusion/ej2-base';
import { isGroupAdaptive } from '../base/util';
import { RowModelGenerator } from '../services/row-model-generator';
import { GroupModelGenerator } from '../services/group-model-generator';
import * as events from '../base/constant';
import * as literals from '../base/string-literals';
/**
 * Content module is used to render grid content
 */
export class VirtualRowModelGenerator {
    constructor(parent) {
        this.cOffsets = {};
        this.cache = {};
        this.movableCache = {};
        this.frozenRightCache = {};
        this.rowCache = {};
        this.data = {};
        this.groups = {};
        this.currentInfo = {};
        this.parent = parent;
        this.model = this.parent.pageSettings;
        this.rowModelGenerator = this.parent.allowGrouping ? new GroupModelGenerator(this.parent) : new RowModelGenerator(this.parent);
    }
    generateRows(data, e) {
        const isFrozen = this.parent.isFrozenGrid();
        let isManualRefresh = false;
        const info = e.virtualInfo = e.virtualInfo || this.getData();
        const xAxis = info.sentinelInfo && info.sentinelInfo.axis === 'X';
        const page = !xAxis && info.loadNext && !info.loadSelf ? info.nextInfo.page : info.page;
        let result = [];
        let indexes = this.getBlockIndexes(page);
        const loadedBlocks = [];
        if (this.currentInfo.blockIndexes) {
            indexes = info.blockIndexes = e.virtualInfo.blockIndexes = this.includePrevPage ? this.currentInfo.blockIndexes.slice(1)
                : this.currentInfo.blockIndexes.slice(0, this.currentInfo.blockIndexes.length - 1);
            isManualRefresh = true;
        }
        if ((isFrozen && (this.parent.getFrozenMode() !== literals.leftRight && !e.renderMovableContent)
            || this.parent.getFrozenMode() === literals.leftRight && !e.renderMovableContent && !e.renderFrozenRightContent) || !isFrozen) {
            this.checkAndResetCache(e.requestType);
        }
        if (isGroupAdaptive(this.parent) && this.parent.vcRows.length) {
            const dataRows = this.parent.vcRows.filter((row) => row.isDataRow);
            if ((this.parent.isManualRefresh && dataRows.length === data['records'].length) || !this.parent.isManualRefresh) {
                return result = this.parent.vcRows;
            }
        }
        if (this.parent.enableColumnVirtualization) {
            for (let i = 0; i < info.blockIndexes.length; i++) {
                if (this.isBlockAvailable(info.blockIndexes[parseInt(i.toString(), 10)])) {
                    this.cache[info.blockIndexes[parseInt(i.toString(), 10)]] =
                        this.rowModelGenerator.refreshRows(this.cache[info.blockIndexes[parseInt(i.toString(), 10)]]);
                }
                if ((e.renderMovableContent && this.isMovableBlockAvailable(info.blockIndexes[parseInt(i.toString(), 10)]))
                    || (e.renderFrozenRightContent && this.isFrozenRightBlockAvailable(info.blockIndexes[parseInt(i.toString(), 10)]))) {
                    const cache = e.renderMovableContent
                        ? this.movableCache : this.frozenRightCache;
                    cache[info.blockIndexes[parseInt(i.toString(), 10)]] =
                        this.rowModelGenerator.refreshRows(cache[info.blockIndexes[parseInt(i.toString(), 10)]]);
                }
            }
        }
        const values = info.blockIndexes;
        for (let i = 0; i < values.length; i++) {
            if (!this.isBlockAvailable(values[parseInt(i.toString(), 10)])) {
                const startIdx = !isNullOrUndefined(this.startIndex) ? this.startIndex :
                    this.getStartIndex(values[parseInt(i.toString(), 10)], data);
                const rows = this.rowModelGenerator.generateRows(data, {
                    virtualInfo: info, startIndex: startIdx
                });
                if (isGroupAdaptive(this.parent) && !this.parent.vcRows.length) {
                    this.parent.vRows = rows;
                    this.parent.vcRows = rows;
                    this.parent.notify(events.refreshVirtualMaxPage, {});
                }
                let median;
                if (isGroupAdaptive(this.parent)) {
                    this.getGroupVirtualRecordsByIndex(rows);
                }
                else {
                    if (isManualRefresh) {
                        this.setBlockForManualRefresh(this.cache, indexes, rows);
                    }
                    else {
                        median = ~~Math.max(rows.length, this.model.pageSize) / 2;
                        if (!this.isBlockAvailable(indexes[0])) {
                            this.cache[indexes[0]] = rows.slice(0, median);
                        }
                        if (!this.isBlockAvailable(indexes[1])) {
                            this.cache[indexes[1]] = rows.slice(median);
                        }
                    }
                }
            }
            if (this.parent.groupSettings.columns.length && !xAxis && this.cache[values[parseInt(i.toString(), 10)]] &&
                !this.parent.groupSettings.enableLazyLoading) {
                this.cache[values[parseInt(i.toString(), 10)]] =
                    this.updateGroupRow(this.cache[values[parseInt(i.toString(), 10)]], values[parseInt(i.toString(), 10)]);
            }
            if ((e.renderMovableContent && !this.isMovableBlockAvailable(values[parseInt(i.toString(), 10)]))
                || (e.renderFrozenRightContent && !this.isFrozenRightBlockAvailable(values[parseInt(i.toString(), 10)]))) {
                const cache = e.renderMovableContent
                    ? this.movableCache : this.frozenRightCache;
                const startIdx = !isNullOrUndefined(this.startIndex) ? this.startIndex :
                    this.getStartIndex(values[parseInt(i.toString(), 10)], data);
                const rows = this.rowModelGenerator.generateRows(data, {
                    virtualInfo: info, startIndex: startIdx
                });
                if (isManualRefresh) {
                    this.setBlockForManualRefresh(cache, indexes, rows);
                }
                else {
                    const median = ~~Math.max(rows.length, this.model.pageSize) / 2;
                    if ((e.renderFrozenRightContent && !this.isFrozenRightBlockAvailable(indexes[0]))
                        || (e.renderMovableContent && !this.isMovableBlockAvailable(indexes[0]))) {
                        cache[indexes[0]] = rows.slice(0, median);
                    }
                    if ((e.renderFrozenRightContent && !this.isFrozenRightBlockAvailable(indexes[1]))
                        || (e.renderMovableContent && !this.isMovableBlockAvailable(indexes[1]))) {
                        cache[indexes[1]] = rows.slice(median);
                    }
                }
            }
            if (!e.renderMovableContent && !e.renderFrozenRightContent && this.cache[values[parseInt(i.toString(), 10)]]) {
                result.push(...this.cache[values[parseInt(i.toString(), 10)]]);
            }
            else {
                const cache = e.renderMovableContent
                    ? this.movableCache : this.frozenRightCache;
                if (cache[values[parseInt(i.toString(), 10)]]) {
                    result.push(...cache[values[parseInt(i.toString(), 10)]]);
                }
            }
            if (this.isBlockAvailable(values[parseInt(i.toString(), 10)])) {
                loadedBlocks.push(values[parseInt(i.toString(), 10)]);
            }
        }
        info.blockIndexes = loadedBlocks;
        const grouping = 'records';
        if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
            this.parent.currentViewData[`${grouping}`] = result.map((m) => m.data);
        }
        else if (isFrozen) {
            if ((e.renderMovableContent && (this.parent.getFrozenMode() === 'Left'
                || this.parent.getFrozenMode() === 'Right' || this.parent.getFrozenColumns())) || e.renderFrozenRightContent) {
                this.parent.currentViewData = result.map((m) => m.data);
            }
        }
        else {
            this.parent.currentViewData = result.map((m) => m.data);
        }
        if (isGroupAdaptive(this.parent) && this.parent.vcRows.length) {
            if (['save', 'delete'].some((value) => { return e.requestType === value; })) {
                return result = this.parent.vcRows;
            }
        }
        return result;
    }
    setBlockForManualRefresh(cache, blocks, rows) {
        const size = this.model.pageSize / 2;
        if (this.includePrevPage) {
            cache[blocks[0] - 1] = rows.slice(0, size);
            cache[blocks[0]] = rows.slice(size, size * 2);
            cache[blocks[1]] = rows.slice(size * 2, size * 3);
            cache[blocks[2]] = rows.slice(size * 3, size * 4);
        }
        else {
            cache[blocks[0]] = rows.slice(0, size);
            cache[blocks[1]] = rows.slice(size, size * 2);
            cache[blocks[2]] = rows.slice(size * 2, size * 3);
            cache[blocks[2] + 1] = rows.slice(size * 3, size * 4);
        }
    }
    getBlockIndexes(page) {
        return [page + (page - 1), page * 2];
    }
    getPage(block) {
        return block % 2 === 0 ? block / 2 : (block + 1) / 2;
    }
    isBlockAvailable(value) {
        return value in this.cache;
    }
    isMovableBlockAvailable(value) {
        return value in this.movableCache;
    }
    isFrozenRightBlockAvailable(value) {
        return value in this.frozenRightCache;
    }
    getData() {
        return {
            page: this.model.currentPage,
            blockIndexes: this.getBlockIndexes(this.model.currentPage),
            direction: 'down',
            columnIndexes: this.parent.getColumnIndexesInView()
        };
    }
    getStartIndex(blk, data, full = true) {
        const page = this.getPage(blk);
        const even = blk % 2 === 0;
        const index = (page - 1) * this.model.pageSize;
        return full || !even ? index : index + ~~(this.model.pageSize / 2);
    }
    getColumnIndexes(content = this.parent.getHeaderContent().querySelector('.' + literals.headerContent)) {
        if (this.parent.isFrozenGrid()) {
            content = content.querySelector('.' + literals.movableHeader);
        }
        const indexes = [];
        let sLeft = content.scrollLeft | 0;
        const keys = Object.keys(this.cOffsets);
        const cWidth = content.getBoundingClientRect().width;
        sLeft = Math.min(this.cOffsets[keys.length - 1] - cWidth, sLeft);
        const calWidth = Browser.isDevice ? 2 * cWidth : cWidth / 2;
        const left = sLeft + cWidth + (sLeft === 0 ? calWidth : 0);
        keys.some((offset) => {
            const iOffset = Number(offset);
            const offsetVal = this.cOffsets[`${offset}`];
            const border = sLeft - calWidth <= offsetVal && left + calWidth >= offsetVal;
            if (border) {
                indexes.push(iOffset);
            }
            return left + calWidth < offsetVal;
        });
        this.addFrozenIndex(indexes);
        return indexes;
    }
    addFrozenIndex(indexes) {
        if (this.parent.getFrozenColumns() && this.parent.enableColumnVirtualization && indexes[0] === 0) {
            for (let i = 0; i < this.parent.getFrozenColumns(); i++) {
                indexes.push(indexes[indexes.length - 1] + 1);
            }
        }
    }
    checkAndResetCache(action) {
        const actions = ['paging', 'refresh', 'sorting', 'filtering', 'searching', 'grouping', 'ungrouping', 'reorder',
            'save', 'delete'];
        if (this.parent.getFrozenColumns() && this.parent.frozenRows && this.parent.enableColumnVirtualization && action === 'reorder') {
            actions.splice(actions.indexOf(action), 1);
        }
        const clear = actions.some((value) => action === value);
        if (clear) {
            this.cache = {};
            this.data = {};
            this.groups = {};
            this.movableCache = {};
            this.frozenRightCache = {};
        }
        return clear;
    }
    refreshColOffsets() {
        let col = 0;
        this.cOffsets = {};
        const gLen = this.parent.groupSettings.columns.length;
        const cols = this.parent.columns;
        const cLen = cols.length;
        const isVisible = (column) => column.visible &&
            (!this.parent.groupSettings.showGroupedColumn ? this.parent.groupSettings.columns.indexOf(column.field) < 0 : column.visible);
        const c = this.parent.groupSettings.columns;
        for (let i = 0; i < c.length; i++) {
            this.cOffsets[parseInt(i.toString(), 10)] = (this.cOffsets[i - 1] | 0) + 30;
        }
        // eslint-disable-next-line prefer-spread
        const blocks = Array.apply(null, Array(cLen)).map(() => col++);
        for (let j = 0; j < blocks.length; j++) {
            blocks[parseInt(j.toString(), 10)] = blocks[parseInt(j.toString(), 10)] + gLen;
            this.cOffsets[blocks[parseInt(j.toString(), 10)]] =
                (this.cOffsets[blocks[parseInt(j.toString(), 10)] - 1] | 0) + (isVisible(cols[parseInt(j.toString(), 10)]) ?
                    parseInt(cols[parseInt(j.toString(), 10)].width, 10) : 0);
        }
    }
    updateGroupRow(current, block) {
        const currentFirst = current[0];
        let rows = [];
        const keys = Object.keys(this.cache);
        for (let i = 0; i < keys.length; i++) {
            if (Number(keys[parseInt(i.toString(), 10)]) < block) {
                rows = [...rows, ...this.cache[keys[parseInt(i.toString(), 10)]]];
            }
        }
        if ((currentFirst && currentFirst.isDataRow) || block % 2 === 0) {
            return current;
        }
        return this.iterateGroup(current, rows);
    }
    iterateGroup(current, rows) {
        const currentFirst = current[0];
        let offset = 0;
        if (currentFirst && currentFirst.isDataRow) {
            return current;
        }
        const isPresent = current.some((row) => {
            return rows.some((oRow, index) => {
                const res = oRow && oRow.data.field !== undefined
                    && oRow.data.field === row.data.field &&
                    oRow.data.key === row.data.key;
                if (res) {
                    offset = index;
                }
                return res;
            });
        });
        if (isPresent) {
            current.shift();
            current = this.iterateGroup(current, rows.slice(offset));
        }
        return current;
    }
    getRows() {
        let rows = [];
        const keys = Object.keys(this.cache);
        for (let i = 0; i < keys.length; i++) {
            rows = [...rows, ...this.cache[keys[parseInt(i.toString(), 10)]]];
        }
        return rows;
    }
    generateCells(foreignKeyData) {
        const cells = [];
        const cols = this.parent.columnModel;
        for (let i = 0; i < cols.length; i++) {
            cells.push(this.rowModelGenerator.generateCell(cols[parseInt(i.toString(), 10)], null, null, null, null, foreignKeyData));
        }
        return cells;
    }
    getGroupVirtualRecordsByIndex(rows) {
        const blocks = this.parent.contentModule.getGroupedTotalBlocks();
        const blockSize = this.parent.contentModule.getBlockSize();
        for (let i = 1; i <= blocks; i++) {
            let count = 0;
            this.cache[parseInt(i.toString(), 10)] = [];
            for (let j = ((i - 1) * blockSize); j < rows.length; j++) {
                if (count === blockSize) {
                    break;
                }
                this.cache[parseInt(i.toString(), 10)].push(rows[parseInt(j.toString(), 10)]);
                if (rows[parseInt(j.toString(), 10)].isDataRow) {
                    count++;
                }
            }
        }
    }
}
